import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useOptionsService } from '#service/autocomplete-service/hooks';
import { ProjectsFilterOptionService } from '#service/autocomplete-service/service';
import { ProjectAutocomplete } from '#component/reports/styles';
import { requestStatuses } from '#helper';

const ProjectSelector = ({ value, onChange }) => {
  const {
    options,
    status,
    fetchOptions,
    clearOptions
  } = useOptionsService(['title'], ProjectsFilterOptionService);

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  const handleInputChange = (event, inputValue) => {
    if (event?.type === 'change') {
      if (inputValue.length >= 2) {
        fetchOptions(inputValue, 300);
      } else if (inputValue === '') {
        fetchOptions('', 0);
      }
    }
  };

  const handleOpen = () => {
    fetchOptions('', 0);
  };

  const handleClose = () => {
    clearOptions();
  };

  const isLoading = status === requestStatuses.loading;

  return (
    <ProjectAutocomplete
      options={options}
      getOptionLabel={option => option?.label || ''}
      value={value}
      onChange={handleChange}
      onInputChange={handleInputChange}
      onOpen={handleOpen}
      onClose={handleClose}
      loading={isLoading}
      isOptionEqualToValue={(option, val) => option?.data?.id === val?.data?.id}
      renderInput={params => (
        <TextField
          {...params}
          label="Project *"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};

export default ProjectSelector;
